//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import AQModal from "@/components/Generics/AQModal/AQModal.vue";

import Modals from "../../mixins/left-menu";

export default {
    name: "UserProfileModal",
    components: { AQModal },
    mixins: [Modals],
    props: {
        isExternal: { type: Boolean, default: false }
    },
    data() {
        return {
            show: true
        };
    }
};
